import FUmkm from "@/models/umkm/f-umkm";

export const umkm = {

  namespaced: true,
  state: {
    itemModified: new FUmkm(),
    itemDefault: {},
    formModeFUmkmFile: String,
    itemsFDivision: [],
    itemsFUmkm: [],
    itemsFUmkmMarker: [],
    allItemsFUmkm: [],
    itemsFArea: [],
    itemsFSubArea: [],

    itemsFPermit:[],
    itemsFtUmkmPermit:[],
    itemsFtUmkmPermitFiltered:[],

    itemsFUmkmType:[],

    checkedItemsFPermit: [],

  },

  actions: {
    updateItemModified({commit}, payload){
      commit('mutateItemModified', payload)
    },
    updateItemDefault({commit}, payload){
      commit('mutateItemDefault', payload)
    },
    updateFormModeFUmkmFile({ commit }, payload) {
      commit("mutateFormModeFUmkmFile", payload);
    },
    updateItemsFDivision({commit}, payload){
      commit('mutateItemsFDivision', payload)
    },
    updateItemsFUmkm({commit}, payload){
      commit('mutateItemsFUmkm', payload)
    },
    mutateItemsFUmkmMarker(state, payLoad) {
      state.itemsFUmkmMarker = payLoad;
    },
    updateAllItemsFUmkm({commit}, payload){
      commit('mutateAllItemsFUmkm', payload)
    },
    updateItemsFArea({commit}, payload){
      commit('mutateItemsFArea', payload)
    },
    updateItemsFSubArea({commit}, payload){
      commit('mutateItemsFSubArea', payload)
    },
    updateItemsFPermit({commit}, payload){
      commit('mutateItemsFPermit', payload)
    },
    updateItemsFtUmkmPermit({commit}, payload){
      commit('mutateItemsFtUmkmPermit', payload)
    },
    updateItemsFtUmkmPermitFiltered({commit}, payload){
      commit('mutateItemsFtUmkmPermitFiltered', payload)
    },
    updateItemsFUmkmType({commit}, payload){
      commit('mutateItemsFUmkmType', payload)
    },

    updateCheckedItemsFPermit({commit}, payload){
      commit('mutateCheckedItemsFPermit', payload)
    },

  },
  mutations: {
    mutateItemModified(state, payLoad){
      state.itemModified = payLoad
    },
    mutateItemDefault(state, payLoad){
      state.itemDefault = payLoad
    },
    mutateFormModeFUmkmFile(state, payLoad){
      state.formModeFUmkmFile = payLoad
    },
    mutateItemsFDivision(state, payLoad) {
      state.itemsFDivision = payLoad;
    },
    mutateItemsFUmkmMarker(state, payLoad) {
      state.itemsFPotensiMarker = payLoad;
    },
    mutateItemsFUmkm(state, payLoad){
      state.itemsFUmkm = payLoad
    },
    mutateAllItemsFUmkm(state, payLoad){
      state.allItemsFUmkm = payLoad
    },
    mutateItemsFArea(state, payLoad){
      state.itemsFArea = payLoad
    },
    mutateItemsFSubArea(state, payLoad){
      state.itemsFSubArea = payLoad
    },
    mutateItemsFPermit(state, payLoad){
      state.itemsFPermit = payLoad
    },
    mutateItemsFtUmkmPermit(state, payLoad){
      state.itemsFtUmkmPermit = payLoad
    },
    mutateItemsFtUmkmPermitFiltered(state, payLoad){
      state.itemsFtUmkmPermitFiltered = payLoad
    },

    mutateItemsFUmkmType(state, payLoad){
      state.itemsFUmkmType = payLoad
    },

    mutateCheckedItemsFPermit(state, payLoad){
      state.checkedItemsFPermit = payLoad
    },

  },


};
